import { Instagram,Mail } from 'lucide-react';
import React from 'react';
import { isQuietShellRoute } from '@/lib/routing/quiet-shell';
import { Link,useLocation } from 'react-router-dom';
import { NewsletterCompact } from './NewsletterCompact';

export function Footer() {
  const location = useLocation();
  if (isQuietShellRoute(location.pathname)) {
    return null;
  }

  return (
    <footer className="bg-surface-primary border-t border-white/5">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left Side - Links Grid */}
          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
              {/* Brand */}
              <div>
                <Link to="/" className="font-brand-display text-2xl tracking-widest text-foreground hover:text-white transition-colors">
                  rendezvous
                </Link>
                <p className="mt-6 text-sm text-foreground/60 font-light leading-relaxed">
                  be open. be uncompromising
                </p>
                <div className="flex gap-6 mt-6">
                  <a href="https://instagram.com/letsrendez.vous" 
                     target="_blank" 
                     rel="noopener noreferrer"
                     className="text-foreground/60 hover:text-white transition-colors">
                    <Instagram className="w-5 h-5" />
                  </a>
                  <a href="mailto:info@letsrendezvous.co" 
                     className="text-foreground/60 hover:text-white transition-colors">
                    <Mail className="w-5 h-5" />
                  </a>
                </div>
              </div>

              {/* Discover */}
              <div>
                <h3 className="text-xs font-bold mb-6 text-foreground uppercase tracking-[0.2em]">Discover</h3>
                <ul className="space-y-4">
                  {/* Cities and Experiences hidden for voice-first focus */}
                  <FooterLink href="/about">About Us</FooterLink>
                </ul>
              </div>

              {/* Legal */}
              <div>
                <h3 className="text-xs font-bold mb-6 text-foreground uppercase tracking-[0.2em]">Legal</h3>
                <ul className="space-y-4">
                  <FooterLink href="/privacy">Privacy Policy</FooterLink>
                  <FooterLink href="/terms">Terms of Service</FooterLink>
                  <FooterLink href="/legal/cookies">Cookies</FooterLink>
                </ul>
              </div>
            </div>
          </div>

          {/* Right Side - Newsletter */}
          <div className="lg:col-span-4">
            <div className="bg-white/5 p-8 rounded-2xl border border-white/5 backdrop-blur-sm">
              <NewsletterCompact variant="stacked" />
              
              {/* Space reserved for future content */}
              <div className="mt-8 pt-8 border-t border-white/5">
                {/* Future: Social proof, trust badges, or member benefits */}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 text-center text-foreground/40 text-sm font-light">
          <p>&copy; {new Date().getFullYear()} rendezvous. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

function FooterLink({ href, children }: { href: string; children: React.ReactNode }) {
  return (
    <li>
      <Link 
        to={href}
        className="text-foreground/60 hover:text-foreground transition-colors text-sm font-light"
      >
        {children}
      </Link>
    </li>
  );
}
